/**
 * @fileoverview Syndicator Showdown — Marquee Ticker
 * @module components/MarqueeTicker
 *
 * Reads ticker config from Firestore game_config/ticker document.
 * Renders a TAB/racecourse scoreboard-style LED ticker between the
 * site header and the hero section on the landing page.
 *
 * Firestore document: game_config/ticker
 *   message: string   — the text to scroll
 *   color:   string   — CSS colour e.g. "#FF3333" or "red"
 *   speed:   number   — 0.1–3.0, default 1.0
 *   enabled: boolean  — show/hide the ticker
 */

import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import './MarqueeTicker.css';

const DEFAULT_CONFIG = {
  message: '',
  color:   '#FF3333',
  speed:   1.0,
  enabled: true,
};

export const MarqueeTicker = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    const ref = doc(db, 'game_config', 'ticker');
    return onSnapshot(ref, snap => {
      if (snap.exists()) {
        setConfig({ ...DEFAULT_CONFIG, ...snap.data() });
      }
    });
  }, []);

  if (!config.enabled || !config.message?.trim()) return null;

  // Speed: 1.0 = 40s for a full scroll cycle. Higher = faster.
  const durationSeconds = Math.round(40 / config.speed);

  // Repeat the message so there's always text on screen
  const repeated = `${config.message}     ✦     ${config.message}     ✦     ${config.message}`;

  return (
    <div className="ss-ticker-wrap">
      {/* Inner container aligns badge + track with page max-width (1400px).
          The outer .ss-ticker-wrap background still fills full viewport width. */}
      <div className="ss-ticker-inner">

        {/* Left label badge */}
        <div className="ss-ticker-label">
          <span className="ss-ticker-label-dot" />
          LIVE
        </div>

        {/* Scrolling track */}
        <div className="ss-ticker-track">
          <div
            className="ss-ticker-content"
            style={{
              color:             config.color,
              animationDuration: `${durationSeconds}s`,
            }}
          >
            {repeated}
          </div>
        </div>

      </div>
    </div>
  );
};

export default MarqueeTicker;
